/* EMEA-only component — do not import outside isEMEAStore() guarded paths */
import { isContractAvailableInCountry } from 'utils/iteroContractUtils';
import { ContentfulRichTextHTML } from 'components/ContentfulRichTextHTML';
import { EmeaContractsProps } from 'components/ITeroTermsConditionsModalEMEA/ITeroTermsConditionsModalEMEA.type';
import { Styled } from 'components/ITeroTermsConditionsModal';

const EmeaContracts = ({
  contentful,
  doctorProfile,
  i18n,
}: EmeaContractsProps) => {
  return (
    <>
      <div>
        <Styled.Title>
          {i18n['ITERO PURCHASE TERMS AND CONDITIONS - EMEA']}
        </Styled.Title>
      </div>

      {/* GENERIC CONTRACTS */}
      <div data-testid="generic-contracts">
        {contentful?.iTeroContractEmea.genericContract?.map(
          contract =>
            isContractAvailableInCountry(
              doctorProfile?.country,
              contract.availableCountries
            ) && (
              <ContentfulRichTextHTML
                key={contract.title}
                document={contract.content}
              />
            )
        )}
      </div>
    </>
  );
};

export default EmeaContracts;
